import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import {Component} from "react";

let source = axios.CancelToken.source();

class Movement_status extends Component {

    constructor() {
        super();
        this.state = {
            stock: 'nav-item',
            objs: [],
            objsload: false,

            reports: [],
            trucks:[],
            reportload: false,

            stdate:'',
            eddate:'',
            sttime:'',
            edtime:'',
            id:-1,
        }
    }
    componentDidMount() {
        let params = (new URL(document.location)).searchParams;
        let veh_id = params.get("veh_id")
        let st = params.get("st");
        let ed = params.get("ed");
        if(veh_id && st &&ed)
        {
            this.setState({
                stdate:st,
                eddate:ed,
                id:veh_id,
            },()=>this.report(1))
        }
        let baseurl = myconfig.getassignmentforreport;
        axios.post(baseurl, {
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                console.log(res.data)
                this.setState({
                    trucks: res.data.datas,
                })

            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    tabledata=()=> {
        let retdata = null;
        if (this.state.reportload) {
            let count = 0;
            retdata = this.state.reports.datas.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>{value.plateno}</td>
                    <td>{value.sttime}</td>
                    <td>{value.stloc}</td>
                    <td>{value.edtime}</td>
                    <td>{value.edloc}</td>
                    <td>{value.dur}</td>
                    <td>{value.km}</td>
                    <td>{value.tatloc}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    getreport = (event,reporttype) => {
        event.preventDefault()
        this.report(reporttype)
    }
    report=(reporttype)=>{
        this.setState({
            reports: [],
            reportload: false,
        })
        let baseurl = myconfig.detmovreport;
        axios.post(baseurl, {
            stdate: this.state.stdate,
            eddate: this.state.eddate,
            sttime: this.state.sttime,
            edtime: this.state.edtime,
            id: this.state.id,
            reporttype: reporttype,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                console.log(res.data)
                this.setState({
                    reports: res.data,
                    stdate: res.data.state.stdate,
                    eddate: res.data.state.eddate,
                    sttime: res.data.state.sttime,
                    edtime: res.data.state.edtime,
                    id: res.data.state.id,
                    reportload: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });

    }
    combotruck=()=>{
        let retdata=this.state.trucks.map(value => {
            return (<option value={value.id}>{value.plateno}</option>)
        });
        return (<>{retdata}</>)
    }
    render() {
        return (
            <>
                <Nav type="movement_status"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Movement Report</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={myconfig.urlwelcome}>Home</a>
                                        </li>
                                        <li className="breadcrumb-item active">Movement</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Report Criteria</h3>
                                            <div className="card-tools">
                                                <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body table-responsive pt-3 px-2" style={{height: '500px'}}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Truck</label>
                                                        <select className="form-control" name="id"
                                                                onChange={this.inputmgt} value={this.state.id}>
                                                            <option value="-1">--Select Truck--</option>
                                                            {this.combotruck()}
                                                        </select>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-9">
                                                            <div className="form-group">
                                                                <label>Start Date</label>
                                                                <input className="form-control" type="date" name="stdate"
                                                                       onChange={this.inputmgt} value={this.state.stdate}/>
                                                            </div>
                                                        </div>
                                                        <div className="col-3">
                                                            <div className="form-group">
                                                                <label>Start time</label>
                                                                <input className="form-control" type="text" name="sttime"
                                                                       onChange={this.inputmgt} value={this.state.sttime} placeholder="HH:MM"/>
                                                            </div>
                                                        </div>
                                                        <div className="col-9">
                                                            <div className="form-group">
                                                                <label>End Date</label>
                                                                <input className="form-control" type="date" name="eddate"
                                                                       onChange={this.inputmgt} value={this.state.eddate}/>
                                                            </div>
                                                        </div>
                                                        <div className="col-3">
                                                            <div className="form-group">
                                                                <label>End time</label>
                                                                <input className="form-control" type="text" name="edtime"
                                                                       onChange={this.inputmgt} value={this.state.edtime} placeholder="HH:MM"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <button className="btn btn-outline-primary form-control" onClick={(event => this.getreport(event,2))}>
                                                            Get Report
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <th>#</th>
                                                <th>Truck</th>
                                                <th>Start Time</th>
                                                <th>Start Location</th>
                                                <th>End Time</th>
                                                <th>End Location</th>
                                                <th>Duration</th>
                                                <th>Millage</th>
                                                <th>Time at Location</th>
                                                </thead>
                                                <tbody>
                                                {this.tabledata()}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* /.card-body */}
                                    </div>
                                    {/* /.card */}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Movement_status;
